import { motion } from "framer-motion";
import { TEST_IDS } from "@/lib/testIds";

const timeline = [
  { year: "2022", title: "Bahçeşehir Üniversitesi", sub: "Beslenme ve Diyetetik — başlangıç" },
  { year: "Ekim 2025", title: "Cerrahpaşa Tıp Fakültesi", sub: "Klinik Beslenme Stajı — başlangıç" },
  { year: "Ekim 2025", title: "FC Barcelona Innovation Hub", sub: "Profesyonel Sporcu Diyetisyeni Diploması — başlangıç" },
  { year: "Mayıs 2026", title: "Professional Diploma in Sports Nutrition", sub: "FC Barcelona Innovation Hub — tamamlandı", status: "Tamamlandı" },
  { year: "Mayıs 2026", title: "Certificate in Sports Nutrition for Football", sub: "FC Barcelona Innovation Hub — tamamlandı", status: "Tamamlandı" },
  { year: "2026", title: "Bahçeşehir Üniversitesi", sub: "Beslenme ve Diyetetik — mezuniyet", status: "Hedef" },
];

const marqueeWords = [
  "Metabolik Beslenme",
  "İnsülin Direnci",
  "Klinik Diyetetik",
  "Multidisipliner Yaklaşım",
  "Futbolcu Beslenmesi",
  "Supplement Danışmanlığı",
  "Kanıta Dayalı",
];

export const About = () => {
  return (
    <section
      id="hakkimda"
      className="relative bg-mesh-soft py-24 md:py-32 border-t border-[#0F2D2A]/8"
    >
      {/* Top marquee — adds motion + reinforces services */}
      <div className="absolute top-0 left-0 right-0 overflow-hidden border-b border-[#0F2D2A]/8 py-3">
        <div className="marquee-track gap-10">
          {[...marqueeWords, ...marqueeWords].map((w, i) => (
            <div
              key={i}
              className="flex items-center gap-10 whitespace-nowrap"
            >
              <span className="font-heading font-black text-sm uppercase tracking-[0.22em] bg-gradient-to-r from-[#10B981] to-[#0EA5E9] bg-clip-text text-transparent">
                {w}
              </span>
              <span className="w-1.5 h-1.5 rounded-full bg-[#0EA5E9]/40" />
            </div>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 pt-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
          {/* Left */}
          <div className="lg:col-span-6">
            <motion.p
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              className="label-eyebrow mb-5"
            >
              01 — Hakkımda
            </motion.p>

            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7 }}
              className="font-heading font-black text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#0F2D2A] leading-[1.02]"
            >
              Klinik disiplin, <br />
              <span className="hl-underline">bilime ve kanıta</span> <br />
              dayalı{" "}
              <span className="bg-gradient-to-r from-[#10B981] to-[#0EA5E9] bg-clip-text text-transparent">
                protokoller.
              </span>
            </motion.h2>

            <div className="mt-10 space-y-6 text-[#1E4842] text-base md:text-lg leading-relaxed max-w-xl">
              <motion.p
                initial={{ opacity: 0, y: 12 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ delay: 0.1 }}
              >
                <span className="font-extrabold text-[#0F2D2A]">
                  Bahçeşehir Üniversitesi
                </span>{" "}
                Beslenme ve Diyetetik bölümündeki akademik eğitimimi,{" "}
                <span className="font-extrabold text-[#0F2D2A]">
                  Cerrahpaşa Tıp Fakültesi&apos;nin
                </span>{" "}
                köklü klinik disiplini ile birleştirdim.
              </motion.p>
              <motion.p
                initial={{ opacity: 0, y: 12 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ delay: 0.18 }}
              >
                Tıbbi beslenme protokolleri uygulamanın yanı sıra{" "}
                <span className="font-extrabold text-[#0F2D2A]">
                  FC Barcelona Innovation Hub
                </span>
                &apos;dan aldığım uluslararası uzmanlık eğitimiyle, klinik
                verileri sporcu performansına ve toparlanma (recovery)
                stratejilerine dönüştürüyorum.
              </motion.p>
              <motion.p
                initial={{ opacity: 0, y: 12 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ delay: 0.26 }}
              >
                Global spor beslenmesi literatürünü yakından takip ediyor;
                kanıta dayalı, performansı optimize eden beslenme protokolleri
                uyguluyorum.
              </motion.p>
            </div>
          </div>

          {/* Right — timeline */}
          <div className="lg:col-span-6">
            <p className="label-eyebrow mb-5">Akademik Yolculuk</p>
            <ol className="relative pl-8 space-y-10">
              {/* gradient rail */}
              <span className="absolute left-0 top-2 bottom-2 w-px bg-gradient-to-b from-[#10B981] via-[#0AB7C5] to-[#0EA5E9]" />
              {timeline.map((it, i) => (
                <motion.li
                  key={i}
                  initial={{ opacity: 0, x: 24 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, margin: "-80px" }}
                  transition={{ duration: 0.5, delay: i * 0.07 }}
                  data-testid={TEST_IDS.about.timelineItem(i)}
                  className="relative group"
                >
                  <motion.span
                    whileInView={{ scale: [0.6, 1.2, 1] }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: i * 0.07 }}
                    className="absolute -left-[37px] top-1.5 w-3.5 h-3.5 rounded-full bg-gradient-to-br from-[#10B981] to-[#0EA5E9] ring-4 ring-[#F5FAF8] shadow-[0_0_0_2px_rgba(14,165,233,0.25)]"
                  />
                  <p className="text-xs font-extrabold uppercase tracking-[0.22em] bg-gradient-to-r from-[#10B981] to-[#0EA5E9] bg-clip-text text-transparent">
                    {it.year}
                  </p>
                  <h3 className="mt-1 font-heading font-extrabold text-xl text-[#0F2D2A] leading-snug">
                    {it.title}
                  </h3>
                  <p className="mt-1 text-sm text-[#1E4842]/80">{it.sub}</p>
                </motion.li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
